import React, { Component } from 'react';

class ComboMarca extends Component {

    render() {
        const { selectCombo, marca, marcaSeleccionada } = this.props

        let firstOption = { Id: -1, Descripcion: "Todos" }

        return (
            <div>
                <select value={marcaSeleccionada} name="marca" className="form-control default-select confirmadorAjusteCargoSeccionSuperiorSelect" onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo("marcaSeleccionada", value)
                }}>
                    <option key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option>
                    {marca && marca.length > 0 && marca.map((item, index) => { return <option style={{ color: "black" }} key={index} value={item.Id}>{item.Descripcion}</option> })}
                </select>
            </div>
        );
    }
}

export default ComboMarca;